import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCircle } from 'react-icons/fa';
import './LegalTerms.css';
import logo from '../../assets/logo-large.png';

const legalItems = [
  { label: 'Privacy Policy', path: '/privacy' },
  { label: 'Terms & Conditions', path: '/terms' },
  { label: 'Disclaimer', path: '/disclaimer' },
  { label: 'IRS Digital Assets', path: 'https://www.irs.gov/businesses/small-businesses-self-employed/digital-assets' },
];

const LegalTerms: React.FC = () => {
  const navigate = useNavigate();

  const handleItemClick = (path: string) => {
    if (path.startsWith('http')) {
      window.open(path, '_blank'); 
    } else {
      navigate(path);
    }
  };

  return (
    <div className="legal-terms-container">
      <header className="legal-terms-header">
        <img src={logo} alt="Logo" className="legal-logo" />
        <h2>Legal Terms</h2>
      </header>

      <ul className="legal-terms-list">
        {legalItems.map((item, index) => (
          <li
            key={index}
            className="legal-terms-item"
            onClick={() => handleItemClick(item.path)}
          >
            <FaCircle className="item-icon" />
            <span className="item-label">{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LegalTerms;
